export enum MarketingEventEnumeration {
  LOGIN_RP = 'LoginRP',
  LOGIN_RF = 'LoginRF',
  REGISTER_RP = 'RegistroRP',
  NEW_REQUEST_RP = 'SolicitudNuevoRP',
  RECURRENT_REQUEST_RP = 'SolicitudRecurrenteRP',
  NEW_APPROVED_RP = 'AprobadaNuevoRP',
  RECURRENT_APPROVED_RP = 'AprobadoRecurrenteRP',
  NEW_ACCEPTED_RP = 'AceptadoNuevoRP',
  RECURRENT_ACCEPTED_RP = 'AceptadoRecurrenteRP',
  INIT_VALIDATION_IDENTITY_RP = 'initValidationIdentityRP',
  FAIL_INIT_VALIDATION_IDENTITY_RP = 'failInitValidationIdentityRP',
  PERSONAL_INFO_RP = 'InfoPersonalRP',
  PERSONAL_DATA_RP = 'DatosPersonalesRP',
  LOAN_APPLICATION_RFYA = 'loanApplicationRFYA',
  LOAN_APPLICATION_SIMULATE_RFYA = 'loanApplicationSimulateRFYA',
  LOAN_APPLICATION_ACCEPTED_RFYA = 'loanApplicationAcceptedRFYA',
  LOAN_APPLICATION_REJECTED_RFYA = 'loanApplicationRejectedRFYA',
  LOAN_APPLICATION_SIGNATURE_RFYA = 'loanApplicationSignatureRFYA',
  LOAN_APPLICATION_APPROVED_RFYA = 'loanApplicationApprovedRFYA',
}
